"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _MenuRounded = _interopRequireDefault(require("@material-ui/icons/MenuRounded"));

var _muiLayout = require("mui-layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var config = _muiLayout.presets.createStandardLayout();

var AdminLayout = function AdminLayout(props) {
  return _react.default.createElement(_muiLayout.Root, {
    config: config
  }, _react.default.createElement(_muiLayout.Header, _extends({
    renderMenuIcon: function renderMenuIcon(open) {
      return open ? _react.default.createElement(_ChevronLeft.default, null) : _react.default.createElement(_MenuRounded.default, null);
    }
  }, props.headerProps), props.header), _react.default.createElement(_muiLayout.Nav, _extends({
    renderIcon: function renderIcon(collapsed) {
      return collapsed ? _react.default.createElement(_ChevronRight.default, null) : _react.default.createElement(_ChevronLeft.default, null);
    }
  }, props.navProps), props.nav), _react.default.createElement(_muiLayout.Content, props.contentProps, props.content), _react.default.createElement(_muiLayout.Footer, props.footerProps, props.footer));
};

AdminLayout.propTypes = {
  header: _propTypes.default.node,
  nav: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  content: _propTypes.default.node,
  footer: _propTypes.default.node,
  headerProps: _propTypes.default.object,
  navProps: _propTypes.default.object,
  contentProps: _propTypes.default.object,
  footerProps: _propTypes.default.object
};
var _default = AdminLayout;
exports.default = _default;